import { TextField } from '@mui/material';

const ShortAnswer: React.FC = (): JSX.Element => (
  <TextField
    sx={{ marginTop: '20px' }}
    inputProps={{
      style: {
        height: '48px',
        width: '709px',
      },
      readOnly: true,
      'data-testid': 'shortTextComponent',
    }}
    variant="outlined"
  />
);

export default ShortAnswer;
